import React from "react";
import Title from "components/Title";
import SearchBox from "components/Filters/SearchBox";

const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="search.title" />

      <SearchBox
        apiName="getSearchWord"
        requestType="FetchRecord"
        recordName="searchWordList"
        placeholder="Keyword"
        customQuery=""
        width="180px"
      />
    </div>
  );
};

export default TableHeader;
